import React from 'react'
import './faqs.scss'
import Accordion from 'react-bootstrap/Accordion';
const Faq = ({heading , FaqData}) => {

    return (
        <>
            <div className="faq-wrapper">
                <div className='heading'>
                    <h2>{heading}</h2>
                </div>
                <Accordion>
                    {FaqData?.map((item) => (
                        <Accordion.Item key={item.id} eventKey={item.eventKey}>
                            <Accordion.Header>{item.header}</Accordion.Header>
                            <Accordion.Body>{item.body}</Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </>
    )
}

export default Faq